import { useState } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";

const useRemoveDealPayment = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const removeDealPayment = async (paymentId) => {
        if (!paymentId) {
            toast.error("Payment ID is required.");
            return;
        }

        setLoading(true);
        setError(null);
        try {
            const response = await post({
                fn: "removeDealPayment",
                paymentId: paymentId,
            });
            toast.success("Payment removed successfully");
            return response;
        } catch (err) {
            toast.error(err.response?.data?.text || "Failed to remove payment");
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, removeDealPayment };
};

export default useRemoveDealPayment;
